import React, { useState, useEffect } from 'react'

// react router
import { Link } from 'react-router-dom';

// bootstrap
import { Spinner } from 'react-bootstrap';

// styles
import { HeaderMenuStyles } from '../../styles/styles.header'

// icons
import { FiChevronUp, FiChevronDown, FiMenu, FiX } from "react-icons/fi";

// APIs
import { getCategoriesTree, cancelGetCategoriesTreeApi } from "utlis/Apis/Categories_API";

// app messages
import {
	UNKNOWN_ERROR_OCCURED,
	ERROR_WHILE__NAME,
} from "utlis/AppMessages/AppMessages";

// sub menu
import SubMenuItem from './SubMenuItem';

export default function Menu(props) {
    // props
    const { commonToken } = props

    // states
    const [menuItems, setMenuItems] = useState([])
    const [dataLoading, setDataLoading] = useState(true)

    const [dropDownActive, setDropDownActive] = useState(false)

    const [mobileMenuVisibility, setMobileMenuVisibility] = useState(false)

    // getting data
    useEffect(() => {
        // enable categories list loading
		setDataLoading(true);

		// getting categories tree
		getCategoriesTree(commonToken ?? "").then((res) => {
			// disabling categories list loading
			setDataLoading(false);

			const catsData = res?.data;

			// if request is success
			if (catsData?.success) {
				// settings categories
				setMenuItems(catsData.data);
			}

			// if request is not succeed
			if (catsData?.error) {
				console.log(UNKNOWN_ERROR_OCCURED, res);
			}
		}).catch((err) => {
			console.log(`${ERROR_WHILE__NAME} getCategoriesTree `, err.message);
		});

        return () => {
            cancelGetCategoriesTreeApi && cancelGetCategoriesTreeApi()
        }
    }, [commonToken])

    // handle dropdown visibility on hover
    const handleDropdownVisibilityHover = () => {
        setDropDownActive(false)
    }

    // handle dropdown visibility on click
    const handleDropdownVisibilityClick = () => {
        setDropDownActive(!dropDownActive)
        // if (window.innerWidth < 992) {
        // }
    }

    // move to about section
    const handleMoveToAbout = ev => {
        ev.preventDefault()

        const elem = document.getElementById("about-sec")
        if(elem) {
            elem.scrollIntoView()
            setMobileMenuVisibility(false) // closing menu
        }
    }

    // move to about section
    const handleMoveToContact = ev => {
        ev.preventDefault()

        const elem = document.getElementById("contact-sec")
        if(elem) {
            elem.scrollIntoView()
            setMobileMenuVisibility(false) // closing menu
        }
    }

    return (
        <HeaderMenuStyles className="menu media-body px-lg-2">
            {/* for mobile */}
            <div className="mobile-icon d-inline-block d-lg-none st-text-primary" onClick={() => setMobileMenuVisibility(true)}>
                <FiMenu fontSize={25} />
            </div>

            <div className={`overlay ${mobileMenuVisibility ? "mobile-menu-active" : ""}`} onClick={() => setMobileMenuVisibility(false)}></div>
            {/* <div className="main-sec">
            </div> */}
            <div className={`menu-inner ${mobileMenuVisibility ? "mobile-menu-active" : ""}`}>
                {/* for mobile */}
                <div className="mobile-icon d-inline-block d-lg-none st-text-primary mb-3" onClick={() => setMobileMenuVisibility(false)}>
                    <FiX fontSize={25} />
                </div>

                <ul className='menu-container list-unstyled d-flex flex-wrap flex-column flex-lg-row justify-content-lg-center mb-0'>
                    {/* menu item */}
                    <li className={`menu-item ${dropDownActive ? "active" : ""}`}
                        onMouseLeave={handleDropdownVisibilityHover}
                        onClick={handleDropdownVisibilityClick}>
                        <Link to={"/home"} className='menu-link cursor-pointer text-decoration-none d-flex align-items-center' onClick={ev => ev.preventDefault()}>
                            <span className='me-1'>Shop</span>
                            {
                                menuItems?.length ? (
                                    <>
                                        {
                                            dropDownActive ? (
                                                <FiChevronUp />
                                            ) : (
                                                <FiChevronDown />
                                            )
                                        }
                                    </>
                                ) : null
                            }
                        </Link>

                        {/* menu */}
                        {
                            menuItems?.length ? (
                                <div className="sub-menu">
                                    {
                                        dataLoading ? (
                                            <div className="loading d-flex justify-content-center px-2">
                                                <Spinner animation="border" size="sm" />
                                            </div>
                                        ) : (
                                            <ul className="list-unstyled mb-0">
                                                {
                                                    menuItems?.length && menuItems.map(item => (
                                                        <SubMenuItem
                                                            key={item.category_id}

                                                            menuItem={item}

                                                            setMobileMenuVisibility={setMobileMenuVisibility}
                                                        />
                                                    ))
                                                }
                                            </ul>
                                        )
                                    }
                                </div>
                            ) : null
                        }
                    </li>

                    {/* menu item */}
                    <li className='menu-item'>
                        <a href="/" className='menu-link cursor-pointer text-decoration-none d-flex align-items-center' onClick={handleMoveToAbout}>
                            <span className='me-1'>About</span>
                        </a>
                    </li>

                    {/* menu item */}
                    <li className='menu-item'>
                        <Link to={"/contact-us"} className='menu-link cursor-pointer text-decoration-none d-flex align-items-center' onClick={handleMoveToContact}>
                            <span className='me-1'>Contact Us</span>
                        </Link>
                    </li>
                </ul>
            </div>
            
        </HeaderMenuStyles>
    )
}
